import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";

// Shared by every map in the app so a place looks the same wherever it's
// pinned (the hub's Map and the Directions drawer).
// Pins are plain DOM because AdvancedMarkerElement takes an element as its
// content. The glyph is rendered from the same react-icons set the rest of the
// app uses, so a pin and its list card always show the same icon.
export const buildPinElement = (category, isProperty) => {
  const size = isProperty ? 44 : 36;
  const wrap = document.createElement("div");
  wrap.style.cssText =
    "display:flex;flex-direction:column;align-items:center;cursor:pointer;" +
    "transform-origin:50% 100%;transition:transform 0.15s ease;";

  const head = document.createElement("div");
  head.style.cssText =
    `width:${size}px;height:${size}px;border-radius:50%;background:${category.color};` +
    `border:3px solid ${isProperty ? "#817EFF" : "#fff"};` +
    "box-shadow:0 3px 8px rgba(0,0,0,0.45);display:flex;align-items:center;justify-content:center;";
  head.innerHTML = renderToStaticMarkup(
    createElement(category.icon, {
      size: isProperty ? 20 : 16,
      color: isProperty ? "#504CFF" : "#fff",
    })
  );

  const tip = document.createElement("div");
  tip.style.cssText =
    "width:0;height:0;margin-top:-2px;border-left:7px solid transparent;" +
    `border-right:7px solid transparent;border-top:9px solid ${isProperty ? "#817EFF" : category.color};`;

  if (!isProperty) {
    wrap.appendChild(head);
    wrap.appendChild(tip);
    return wrap;
  }

  // The property is the anchor of the map, so it's the one pin that is
  // labelled and pulses — a guest should find "home" without hunting.
  const label = document.createElement("div");
  label.textContent = "Your stay";
  label.style.cssText =
    "background:#817EFF;color:#fff;font-size:11px;font-weight:800;letter-spacing:0.04em;" +
    "padding:3px 10px;border-radius:999px;margin-bottom:5px;white-space:nowrap;" +
    "box-shadow:0 2px 6px rgba(0,0,0,0.4);font-family:inherit;";

  const headHolder = document.createElement("div");
  headHolder.style.cssText = `position:relative;width:${size}px;height:${size}px;`;

  const ring = document.createElement("div");
  ring.style.cssText =
    "position:absolute;top:0;left:0;right:0;bottom:0;border-radius:50%;" +
    "background:rgba(129,126,255,0.55);pointer-events:none;";
  // Web Animations API rather than CSS keyframes, so there's no stylesheet to
  // inject and nothing to clean up when the marker is removed.
  if (typeof ring.animate === "function") {
    ring.animate(
      [
        { transform: "scale(1)", opacity: 0.7 },
        { transform: "scale(2.4)", opacity: 0 },
      ],
      { duration: 1800, iterations: Infinity, easing: "ease-out" }
    );
  }

  head.style.position = "relative";
  headHolder.appendChild(ring);
  headHolder.appendChild(head);

  wrap.appendChild(label);
  wrap.appendChild(headHolder);
  wrap.appendChild(tip);
  return wrap;
};
